/* Diviora Theme JS */
(function () {
  'use strict';

  // --- NAV TRANSPARENCY (home page - dark hero at top, cream+dark on scroll) ---
  const topnav = document.querySelector('.topnav');
  if (document.body.classList.contains('template-index') && topnav) {
    function updateNav() {
      topnav.classList.toggle('nav-transparent', window.scrollY < 80);
    }
    window.addEventListener('scroll', updateNav, { passive: true });
    updateNav();
  }


  // --- MOBILE MENU ---
  const menuBtn = document.getElementById('mobile-menu-btn');
  const mobileMenu = document.getElementById('mobile-menu');
  const menuClose = document.getElementById('mobile-menu-close');

  if (menuBtn && mobileMenu) {
    const openMenu = () => {
      mobileMenu.classList.add('open');
      mobileMenu.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    };
    const closeMenu = () => {
      mobileMenu.classList.remove('open');
      mobileMenu.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    };
    menuBtn.addEventListener('click', openMenu);
    if (menuClose) menuClose.addEventListener('click', closeMenu);
    mobileMenu.querySelectorAll('[data-close-menu]').forEach(el => el.addEventListener('click', closeMenu));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && mobileMenu.classList.contains('open')) closeMenu();
    });
  }

  // --- ACCORDION / EXPAND ROWS ---
  document.querySelectorAll('.expand-row-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      btn.closest('.expand-row').classList.toggle('open');
    });
  });

  // --- SHOP FILTER ---
  const filterBtns = document.querySelectorAll('.filter-btn[data-filter]');
  const productItems = document.querySelectorAll('[data-product-item]');

  if (filterBtns.length && productItems.length) {
    filterBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        filterBtns.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        const filter = btn.dataset.filter;
        productItems.forEach(item => {
          if (filter === 'all' || item.dataset.category === filter) {
            item.classList.remove('hidden');
          } else {
            item.classList.add('hidden');
          }
        });
        // Update count display
        const visible = filter === 'all'
          ? productItems.length
          : Array.from(productItems).filter(i => i.dataset.category === filter).length;
        const countEl = document.querySelector('.shop-count');
        if (countEl) countEl.textContent = visible + ' objects';
      });
    });
  }

  // --- PRODUCT GALLERY ---
  const thumbs = document.querySelectorAll('.gallery-thumb');
  const mainImg = document.querySelector('.gallery-main img');
  if (thumbs.length && mainImg) {
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
        mainImg.src = thumb.dataset.src;
      });
    });
  }

  // --- PRODUCT SHARE: copy link ---
  document.querySelectorAll('.product-share__copy').forEach(btn => {
    btn.addEventListener('click', async () => {
      const url = btn.dataset.url;
      if (!url) return;
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(url);
        } else {
          const ta = document.createElement('textarea');
          ta.value = url; ta.style.position = 'fixed'; ta.style.opacity = '0';
          document.body.appendChild(ta); ta.select();
          document.execCommand('copy'); document.body.removeChild(ta);
        }
        btn.classList.add('copied');
        btn.setAttribute('aria-label', 'Link copied');
        setTimeout(() => {
          btn.classList.remove('copied');
          btn.setAttribute('aria-label', 'Copy link');
        }, 1600);
      } catch (e) {}
    });
  });

  // --- PRODUCT GALLERY: thumbnail-anchor sync ---
  const thumbLinks = document.querySelectorAll('.product-thumb-link');
  const imageTiles = document.querySelectorAll('.product-image-tile');
  if (thumbLinks.length && imageTiles.length && 'IntersectionObserver' in window) {
    const tileById = {};
    imageTiles.forEach(tile => { if (tile.id) tileById[tile.id] = tile; });
    const setActive = id => {
      thumbLinks.forEach(link => {
        link.classList.toggle('active', link.dataset.target === id);
      });
    };
    const observer = new IntersectionObserver(entries => {
      const visible = entries
        .filter(e => e.isIntersecting)
        .sort((a, b) => b.intersectionRatio - a.intersectionRatio);
      if (visible.length) setActive(visible[0].target.id);
    }, { rootMargin: '-40% 0px -40% 0px', threshold: [0, 0.25, 0.5, 0.75, 1] });
    imageTiles.forEach(tile => observer.observe(tile));
  }

  // --- PRODUCT GALLERY: mobile swipe carousel + dots ---
  document.querySelectorAll('[data-product-gallery]').forEach(gallery => {
    const dotsWrap = gallery.parentElement.querySelector('[data-gallery-dots]');
    if (!dotsWrap) return;
    const slides = gallery.querySelectorAll('[data-gallery-slide]');
    const dots = dotsWrap.querySelectorAll('[data-gallery-dot]');
    if (!slides.length || !dots.length) return;

    const setActiveDot = idx => {
      dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
    };

    // Sync dot to whichever slide is most visible
    if ('IntersectionObserver' in window) {
      const dotObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.55) {
            const idx = Array.from(slides).indexOf(entry.target);
            if (idx !== -1) setActiveDot(idx);
          }
        });
      }, { root: gallery, threshold: [0.4, 0.55, 0.7] });
      slides.forEach(slide => dotObserver.observe(slide));
    }

    // Click dot → scroll to corresponding slide
    dots.forEach((dot, idx) => {
      dot.addEventListener('click', () => {
        const slide = slides[idx];
        if (slide) {
          gallery.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        }
      });
    });
  });

  // --- QUANTITY PICKER ---
  document.querySelectorAll('.qty-picker').forEach(picker => {
    const input = picker.querySelector('input[type="number"]');
    picker.querySelector('.qty-minus')?.addEventListener('click', () => {
      if (parseInt(input.value) > 1) input.value = parseInt(input.value) - 1;
      updateAddToCartTotal(picker);
    });
    picker.querySelector('.qty-plus')?.addEventListener('click', () => {
      input.value = parseInt(input.value) + 1;
      updateAddToCartTotal(picker);
    });
  });

  function updateAddToCartTotal(picker) {
    if (picker.dataset.noTotal === 'true') return;
    const input = picker.querySelector('input[type="number"]');
    const price = parseInt(picker.dataset.price || 0);
    const btn = document.querySelector('.add-to-cart-btn');
    if (btn && price) {
      const qty = parseInt(input.value);
      const total = (price * qty / 100).toFixed(0);
      const symbol = picker.dataset.currency || '$';
      btn.textContent = `Add to cart · ${symbol}${total}`;
    }
  }

  // --- CART AJAX UPDATE ---
  document.querySelectorAll('[data-cart-qty]').forEach(form => {
    const id = form.dataset.variantId;
    const minusBtn = form.querySelector('.qty-minus');
    const plusBtn = form.querySelector('.qty-plus');
    const qtyDisplay = form.querySelector('.qty-display');

    function updateCart(newQty) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: id, quantity: newQty }),
      })
        .then(r => r.json())
        .then(() => { location.reload(); });
    }

    minusBtn?.addEventListener('click', () => {
      const current = parseInt(qtyDisplay.textContent);
      updateCart(Math.max(0, current - 1));
    });
    plusBtn?.addEventListener('click', () => {
      const current = parseInt(qtyDisplay.textContent);
      updateCart(current + 1);
    });
  });

  // --- CART DRAWER ---
  const cartDrawer = document.getElementById('cart-drawer');
  const cartItemsEl = document.getElementById('cart-drawer-items');
  const cartSubtotalEl = document.getElementById('cart-drawer-subtotal');

  function formatMoney(cents) {
    const n = (cents / 100);
    return '$' + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2));
  }

  function updateCartCounts(count) {
    document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = count);
    document.querySelectorAll('[data-cart-count-paren]').forEach(el => el.textContent = '(' + count + ')');
  }

  function renderCart(cart) {
    if (!cartItemsEl) return;
    if (cart.item_count === 0) {
      cartItemsEl.innerHTML = '<div class="cart-drawer-empty"><div style="font-family:var(--display);font-style:italic;font-size:22px;margin-bottom:14px;">Your bag is quiet.</div><button type="button" class="btn btn-outline" data-close-cart>Begin browsing →</button></div>';
    } else {
      cartItemsEl.innerHTML = cart.items.map(item => {
        const img = item.image ? `<img src="${item.image}" alt="${item.product_title}">` : '<div style="width:72px;height:88px;background:var(--cream-deep);"></div>';
        const variant = (item.variant_title && !/default/i.test(item.variant_title)) ? `<div class="meta">${item.variant_title}</div>` : '';
        return `<div class="cart-drawer-item" data-line-key="${item.key}">
          ${img}
          <div>
            <a href="${item.url}" class="ttl">${item.product_title}</a>
            ${variant}
            <div class="meta">Qty ${item.quantity}</div>
            <button type="button" class="remove" data-remove="${item.key}">Remove</button>
          </div>
          <div class="price">${formatMoney(item.final_line_price)}</div>
        </div>`;
      }).join('');
    }
    if (cartSubtotalEl) cartSubtotalEl.textContent = formatMoney(cart.total_price);
    updateCartCounts(cart.item_count);
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(r => r.json())
      .then(cart => { renderCart(cart); return cart; });
  }

  function openCart() {
    if (!cartDrawer) return;
    fetchCart();
    cartDrawer.classList.add('open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (cartDrawer) {
    document.querySelectorAll('[data-open-cart]').forEach(el => {
      el.addEventListener('click', e => {
        if (e.metaKey || e.ctrlKey || e.shiftKey) return;
        e.preventDefault();
        openCart();
      });
    });
    document.addEventListener('click', e => {
      if (e.target.closest('[data-close-cart]')) {
        closeCart();
        return;
      }
      const rem = e.target.closest('[data-remove]');
      if (rem && cartDrawer.contains(rem)) {
        e.preventDefault();
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: rem.dataset.remove, quantity: 0 })
        }).then(r => r.json()).then(cart => renderCart(cart));
      }
    });
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && cartDrawer.classList.contains('open')) closeCart();
    });
  }

  // --- ATC AJAX INTERCEPT ---
  document.querySelectorAll('form[action$="/cart/add"]').forEach(form => {
    form.addEventListener('submit', e => {
      e.preventDefault();
      const btn = form.querySelector('button[type="submit"], [type="submit"]');
      const originalLabel = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      })
        .then(r => r.json().then(data => ({ ok: r.ok, data })))
        .then(({ ok, data }) => {
          if (!ok) {
            if (btn) btn.textContent = data.description || 'Unavailable';
            setTimeout(() => { if (btn) { btn.disabled = false; btn.textContent = originalLabel; } }, 1800);
            return;
          }
          return fetchCart().then(() => {
            openCart();
            if (btn) { btn.disabled = false; btn.textContent = originalLabel; }
          });
        })
        .catch(() => {
          if (btn) { btn.disabled = false; btn.textContent = originalLabel; }
        });
    });
  });

  // --- SCROLL TO TOP ---
  const scrollTopBtn = document.getElementById('scroll-top-btn');
  if (scrollTopBtn) {
    scrollTopBtn.hidden = false;
    const toggleScrollBtn = () => {
      scrollTopBtn.classList.toggle('visible', window.scrollY > 600);
    };
    window.addEventListener('scroll', toggleScrollBtn, { passive: true });
    toggleScrollBtn();
    scrollTopBtn.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  // --- HERO SCROLL CUE ---
  document.querySelectorAll('[data-scroll-next]').forEach(btn => {
    btn.addEventListener('click', () => {
      const heroWrapper = btn.closest('.shopify-section') || btn.closest('.hero-cinematic') || btn.closest('section');
      let target = heroWrapper?.nextElementSibling;
      while (target && (target.tagName === 'STYLE' || target.tagName === 'SCRIPT' || target.tagName === 'LINK')) {
        target = target.nextElementSibling;
      }
      if (!target) target = document.querySelector('main > *:nth-child(2)');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  // --- SEARCH OVERLAY ---
  const searchOverlay = document.getElementById('search-overlay');
  const searchBtn = document.getElementById('search-btn');
  if (searchBtn && searchOverlay) {
    const openSearch = () => {
      searchOverlay.classList.add('open');
      searchOverlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      const inp = searchOverlay.querySelector('input[name="q"]');
      if (inp) setTimeout(() => inp.focus(), 120);
    };
    const closeSearch = () => {
      searchOverlay.classList.remove('open');
      searchOverlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    };
    searchBtn.addEventListener('click', openSearch);
    searchOverlay.querySelectorAll('[data-close-search], #search-overlay-close').forEach(el => {
      el.addEventListener('click', closeSearch);
    });
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && searchOverlay.classList.contains('open')) closeSearch();
    });
  }

  // --- NEWSLETTER FORM PREVENT DEFAULT (demo only) ---
  document.querySelectorAll('.newsletter-form').forEach(form => {
    form.addEventListener('submit', e => {
      e.preventDefault();
      const input = form.querySelector('input');
      if (input) input.value = '';
      const msg = form.nextElementSibling;
      if (msg) msg.style.opacity = '1';
    });
  });

  // --- KIT CARD HOVER (CSS handles, JS fallback for touch) ---
  // handled via CSS .kit-card:hover rules

})();
